export default function withGuard(Component, session, index) {
  if (index > 1) {
    if (!session[`step${index - 1}`].completed) {
      window.history.back();
      return null;
    }
  }
  return Component;
}



// WEBPACK FOOTER //
// ./src/services/guard.js